/* pnx-recipes.js v4 — shared helpers: mode toggle, saved recipes (local until My Bar lands), formatting. */
(function () {
  var W = window, D = document, LS = null;
  try { LS = W.localStorage; } catch (e) { LS = null; }
  function get(k, d) { try { var v = LS && LS.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  function set(k, v) { try { LS && LS.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---- mode: speakeasy | rave ---- */
  var mode = get('pnx.mode', 'speakeasy');
  D.documentElement.setAttribute('data-pnx-mode', mode);
  function setMode(m) {
    mode = m; D.documentElement.setAttribute('data-pnx-mode', m); set('pnx.mode', m);
    D.querySelectorAll('.pnx-mode__btn').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mode === m)); });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pnx-mode__btn');
    if (b) setMode(b.dataset.mode);
  });
  D.addEventListener('DOMContentLoaded', function () { setMode(mode); });

  /* ---- saved recipes (handles) ---- */
  function saved() { return get('pnx.saved', []); }
  function isSaved(h) { return saved().indexOf(h) !== -1; }
  function toggleSaved(h) {
    var s = saved(), i = s.indexOf(h);
    if (i === -1) s.push(h); else s.splice(i, 1);
    set('pnx.saved', s); return i === -1;
  }

  /* ---- units ---- */
  function fmtOz(n) {
    if (n === 0) return '';
    var r = Math.round(n * 4) / 4; // quarter oz
    var whole = Math.floor(r), frac = r - whole, f = { 0.25: '¼', 0.5: '½', 0.75: '¾' }[frac] || '';
    return (whole ? whole : '') + f || '0';
  }
  function fmtMl(n) { return String(Math.round(n * 29.5735 / 5) * 5); }

  /* ---- account sync (customer metafields via /apps/bar/me; only when window.pnxLoggedIn) ---- */
  var PROXY = W.pnxProxy || '/apps/bar';
  function me() { return fetch(PROXY + '/me', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }); }
  function pullSaved() {
    if (!W.pnxLoggedIn) return Promise.resolve(saved());
    return me().then(function (j) {
      var srv = (j && j.recipes && j.recipes.saved) || [], loc = saved(), changed = false;
      srv.forEach(function (h) { if (loc.indexOf(h) === -1) { loc.push(h); changed = true; } });
      if (changed) set('pnx.saved', loc);
      return loc;
    }).catch(function () { return saved(); });
  }
  function pushSaved() {
    if (!W.pnxLoggedIn) return Promise.resolve(false);
    return me().then(function (j) {
      var rec = (j && j.recipes) || { saved: [], made: [], want: [], strict: false };
      rec.saved = saved();
      return fetch(PROXY + '/me', { method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ recipes: rec }) }).then(function (r) { return r.ok; });
    }).catch(function () { return false; });
  }

  /* ---- desktop scroll arrows for horizontal scrollers (pointer:fine only; CSS hides them on touch) ---- */
  function glide(el, to) { var from = el.scrollLeft, d = to - from, t0 = null, dur = 320; if (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.scrollLeft = to; return; } function step(ts) { if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur); p = 1 - Math.pow(1 - p, 3); el.scrollLeft = from + d * p; if (p < 1) W.requestAnimationFrame(step); } W.requestAnimationFrame(step); }
  function arrows(track) {
    if (track.dataset.pnxArrows) return; track.dataset.pnxArrows = '1';
    var wrap = D.createElement('div'); wrap.className = 'pnx-scroller';
    track.parentNode.insertBefore(wrap, track); wrap.appendChild(track);
    function mk(dir) { var b = D.createElement('button'); b.type = 'button'; b.className = 'pnx-scroller__btn pnx-scroller__btn--' + dir; b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right'); b.innerHTML = dir === 'prev' ? '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="m6 3 5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; b.addEventListener('click', function () { var kids = track.children, step = 0; if (kids.length > 1) step = kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left; if (!step || step < 40) step = Math.max(200, track.clientWidth * 0.8); var per = Math.max(1, Math.floor(track.clientWidth / step) - 1); var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0; var idx = Math.round((track.scrollLeft - pad) / step); var target = pad + (idx + (dir === 'prev' ? -per : per)) * step; glide(track, Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth))); }); wrap.appendChild(b); return b; }
    var prev = mk('prev'), next = mk('next');
    function upd() { var max = track.scrollWidth - track.clientWidth; var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0; wrap.classList.toggle('has-prev', track.scrollLeft > pad + 1); wrap.classList.toggle('has-next', track.scrollLeft < max - 1); wrap.classList.toggle('is-scrollable', max > 4); }
    track.addEventListener('scroll', upd, { passive: true });
    new MutationObserver(upd).observe(track, { childList: true, subtree: true });
    if (W.ResizeObserver) new ResizeObserver(upd).observe(track);
    upd();
  }
  function initArrows(root) { (root || D).querySelectorAll('[data-pnx-scroller]').forEach(arrows); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initArrows(); }); else initArrows();

  W.pnxRecipes = { initArrows: initArrows, get: get, set: set, saved: saved, isSaved: isSaved, toggleSaved: toggleSaved, pullSaved: pullSaved, pushSaved: pushSaved, fmtOz: fmtOz, fmtMl: fmtMl, setMode: setMode };
})();
